export default __webpack_public_path__ + "static/media/card-backface.4a14d9e9.png";